import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import { CustomLinearProgress } from "../../../../Components/CustomLinearProgress/CustomLinearProgress";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class AddAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        title: "",
        files: "",
        subject: "",
        submissionDate: "",
      },
      tempFiles: [],
      fileUrl: [],
      fileLoading: "",
      filePercentage: "",
      fileError: "",
      fileToDelete: "",
      deleteFile: false,
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleFile = async (e) => {
    let files = e.target.files;
    this.setState({
      tempFiles: files,
      fileLoading: true,
      fileUrl: [],
    });

    for (let i = 0; i <= e.target.files.length - 1; i++) {
      let file = e.target.files[i];
      let reader = new FileReader();
      reader.onload = () => {
        this.setState({
          fileUrl: [...this.state.fileUrl, window.URL.createObjectURL(file)],
        });
      };
      reader.readAsDataURL(file);
      reader.onprogress = (data) => {
        this.setState({
          fileLoading: false,
        });
        if (data.lengthComputable) {
          var progress = parseInt((data.loaded / data.total) * 100, 10);
          this.setState({
            filePercentage: progress,
          });
        }
      };
    }
  };

  handleFileProgress = () =>
    this.state.filePercentage ? (
      <React.Fragment>
        <CustomLinearProgress
          value={this.state.filePercentage}
          variant="determinate"
        />
        {this.state.filePercentage === 100 ? (
          <React.Fragment>Upload Complete</React.Fragment>
        ) : (
          <React.Fragment>{this.state.filePercentage}%</React.Fragment>
        )}
      </React.Fragment>
    ) : null;

  uploadFile = async (files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: "Assignment",
      contentType: files.type,
    });
    await Axios.put(signedUrl, files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  filterData = (data) => {
    let changedData = data;
    if (!data.faculty) {
      delete changedData.faculty;
    }

    if (!data.group) {
      delete changedData.group;
    }

    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });
      let data = {
        ...this.state.data,
        session: this.props.config.session.toString(),
        studentClass: this.props.config.class,
        faculty: this.props.config.faculty,
        group: this.props.config.group,
        section: this.props.config.section,
      };
      let fileKeys = [];
      for (let i = 0; i <= this.state.tempFiles.length - 1; i++) {
        fileKeys.push(await this.uploadFile(this.state.tempFiles[i]));
      }
      let changedData = this.filterData(data);
      let toSubmitData = { ...changedData, files: fileKeys };
      const response = await Axios.post(
        `${url}/api/assignments`,
        toSubmitData,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      console.log(response.data);
      if (response.data.message === "Assignment added successfully") {
        this.setState({
          data: {
            title: "",
            files: "",
            subject: "",
            submissionDate: "",
          },
          loading: false,
          tempFiles: [],
          fileUrl: [],
          fileLoading: "",
          filePercentage: "",
          fileError: "",
        });
        this.props.getAssignments();
      }
    } catch (error) {
      this.setState({ loading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <TableRow>
        <TableCell align="center" colSpan={2}>
          <TextField
            name="title"
            type="text"
            required
            fullWidth
            placeholder="E.g, Chapter 1 notes, syllabus and more"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.title}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          {this.state.fileUrl.length > 0 ? (
            <CheckCircleIcon />
          ) : (
            this.state.data.files && <CheckCircleIcon />
          )}
          <div>
            <input
              type="file"
              multiple
              accept="application/*"
              onChange={this.handleFile}
            />
            <div>
              <div style={{ padding: 10 }}>{this.handleFileProgress()}</div>
              <div>
                {this.state.fileLoading === true && <CircularProgress />}
              </div>
            </div>
            <div style={{ color: "red", fontWeight: "bold" }}>
              {this.state.fileError}
            </div>
          </div>
        </TableCell>
        <TableCell align="center">
          <TextField
            name="subject"
            select
            required
            fullWidth
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.subject}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            {this.props.subjects.map((subject, index) => (
              <option key={index} value={subject.name}>
                {subject.name}
              </option>
            ))}
          </TextField>
        </TableCell>
        <TableCell align="center">
          <TextField
            name="submissionDate"
            type="date"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.submissionDate}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <Tooltip
            arrow
            title="Add"
            className={classes.tooltip}
            onClick={this.handleSubmit}
          >
            <AddCircleIcon />
          </Tooltip>
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddAssignment)));
